import { Grid, Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import CustomText from 'components/common/CustomText/CustomText';
import { colors } from 'styles/colors';
import { hexWithOpacity } from 'common/utils';
import NotificationCard from '../NotificationCard/NotificationCard';
import DashboardInvitationCard from '../DashboardInvitationCard/DashboardInvitationCard';
import BellIcon from 'icons/BellIcon';
import { useGetProcedureInvitations } from 'hooks/useProcedure';
import { useGetInvitations } from 'hooks/useUsers';
import { useAuth } from 'context/AuthContext';
import { addRefetchListener } from 'services/appNotificationsService';

export default function InvitationsPanel() {
  const { user } = useAuth();

  const { data: procedureData, isLoading: isProcedureLoading, refetch: refetchProcedure } = useGetProcedureInvitations();
  const { data: dashboardData, isLoading: isDashboardLoading, refetch: refetchDashboard } = useGetInvitations(user.id);

  useEffect(() => {
    return addRefetchListener('refetchInvitations', () => {
      refetchProcedure();
      refetchDashboard();
    });
  }, [refetchProcedure, refetchDashboard]);

  const isLoading = isProcedureLoading || isDashboardLoading;

  const procedureInvitations = procedureData?.data?.results ?? [];
  const dashboardInvitations = dashboardData?.doctors ?? [];

  const hasAny = procedureInvitations.length > 0 || dashboardInvitations.length > 0;

  if (isLoading) {
    return (
      <Grid container spacing={2}>
        {Array.from({ length: 16 }).map((_, index) => (
          <Grid key={index} size={{ xs: 12, md: 6, lg: 3 }}>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!hasAny) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        textAlign="center"
        gap={2}
        minHeight={'40vh'}
      >
        <Box height={100}>
          <BellIcon
            size={100}
            color={hexWithOpacity(colors.secondary, 0.4)}
          />
        </Box>
        <CustomText text="You're all caught up!" fontWeight={600} color={colors.secondary} />
        <CustomText text="New invitations will appear here when you receive them" color={colors.secondary} />
      </Box>
    );
  }

  return (
    <Box>
      {dashboardInvitations.length > 0 && (
        <Box mb={3}>
          <Typography variant="subtitle2" color={colors.secondary} mb={1.5} fontWeight={600}>
            Dashboard Invitations
          </Typography>
          <Grid container spacing={2}>
            {dashboardInvitations.map((item: any) => (
              <Grid key={item.id} size={{ xs: 12, md: 6, lg: 3 }}>
                <DashboardInvitationCard item={item} refetch={refetchDashboard} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {procedureInvitations.length > 0 && (
        <Box>
          {dashboardInvitations.length > 0 && (
            <Typography variant="subtitle2" color={colors.secondary} mb={1.5} fontWeight={600}>
              Procedure Invitations
            </Typography>
          )}
          <Grid container spacing={2}>
            {procedureInvitations.map((item: any) => (
              <Grid key={item.id} size={{ xs: 12, md: 6, lg: 3 }}>
                <NotificationCard item={item} refetch={refetchProcedure} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
}
